function Notes() {
  return <>notes</>
}

export default Notes
